// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2SP7t","header":"PatientQuestionnaire_header__WeqwU","info":"PatientQuestionnaire_info__34BwY"};